const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { Promise } = require('es6-promise');
const { APIGet } = require('utilities/APIRequestHelper');
const { getExchangeAvailability } = require('./brokerExchangeAvailability');

function reset() {
    return {
        type: actionTypes.BROKER_PRODUCT_FILE_RESET
    };
}

const requestProductFileSuccess = (response) => {
    return {
        type: actionTypes.BROKER_GET_PRODUCT_FILE_SUCCESS,
        payload: {
            data: response
        }
    };
}

const requestStocksCatalogueFetching = () => {
    return {
        type: actionTypes.BROKER_GET_PRODUCT_CATALOGUE_FETCHING
    };
};

const requestStocksCatalogueSuccess = (data) => {
    return {
        type: actionTypes.BROKER_GET_PRODUCT_CATALOGUE_SUCCESS,
        payload: data,
    };
};

const requestStocksCatalogueFailure = () => {
    return {
        type: actionTypes.BROKER_GET_PRODUCT_CATALOGUE_FAILURE
    };
};

const requestProductFileFailure = (response) => {
    return {
        type: actionTypes.BROKER_GET_PRODUCT_FILE_FAILURE,
        payload: {
            data: response
        }
    };
}

const getStocksCatalogueDetails = (isin) => (dispatch) => {
    const requestData = {
        query: {
            text: isin,
            pageSize: 5,
            pageSizeGroup: 10,
            pageNumber: 1,
        }
    };

    dispatch(requestStocksCatalogueFetching());

    return APIGet(dispatch, apiURLBuilder.getURL('catalogueBrokerAdvancedSearch'), requestData)
        .then((response) => dispatch(requestStocksCatalogueSuccess(response)))
        .catch(() => dispatch(requestStocksCatalogueFailure()))
}

const getProductFileAction = (dispatch, isin, iso, screen, productFile = 'productFile') => {
    return new Promise(function() {
        const requestData = {
            isin,
            iso
        };

        dispatch({type: actionTypes.BROKER_GET_PRODUCT_FILE_FETCHING});
        const params = {
            query: {
            screen
            }
        };
        return APIGet(dispatch, apiURLBuilder.getURL(productFile, requestData), params)
            .then(function(response) {
                dispatch(requestProductFileSuccess(response));
                if (typeof response.exchangeId !== "undefined") {
                    dispatch(getExchangeAvailability(response.exchangeId));
                }
            })
            .catch(function(response) {
                dispatch(requestProductFileFailure(response));
            }
        );
    });
};

const getProductFile = (isin, iso, screen) => dispatch => getProductFileAction(dispatch, isin, iso, screen);

const getProductFileWithCatalogData = (isin, iso, screen) => dispatch => getProductFileAction(dispatch, isin, iso, screen, 'productFileWithCatalogData');

module.exports = {
    getProductFile,
    getProductFileWithCatalogData,
    getProductFileAction,
    getStocksCatalogueDetails,
    reset
};
